export default [
  /**
   * 系统医院列表
   **** query
   * s
   */
  {
    path: '/public/hos',
    component: () => import('../pages/public/hos')
  },
]



// WEBPACK FOOTER //
// ./src/router/public.js